module.exports = __webpack_public_path__ + "img/6.4.NH3-N.11741f88.png";